const ORDER_DETAILS_MESSAGES = {
  ERROR_MESSAGE: "Oops! Something went wrong.",
};

const MY_ORDERS = {
  BUTTON_TEXT: "view details",
};

const ORDER_DETAILS = {
  ORDERDETAILS_FOOTER: {
    MESSAGE: "You need some help?",
    CONTACT_US: "CONTACT US",
  },
  CURRENCY: "Rs",
  CAROUSEL_SIZE: {
    XS: 1,
    SM: 3,
    MD: 3,
    LG: 3,
  },
  APP_BREAKPOINTS: {
    XS: 768,
    SM: 992,
    MD: 1200,
  },
  PRICE_OVERVIEW_TITLE: "PRICE DETAILS",
  DELIVERY_STATUS_TITLE: "STATUS",
  TRACKING_TITLE: "TRACKING NUMBER",
  DELIVERY_ADDRESS_TITLE: "DELIVERY ADDRESS",
  STORE_PICK: "Store Pickup",
  CAROUSEL_SIZE: 3,
  TRACKING_LINK: "TRACK IT",
  ORDER_SUMMARY: {
    TITLE: "Order Summary",
    ORDERED_ON: "ORDERED ON",
    STATUS: "STATUS",
    ORDER_NUMBER: "ORDER NUMBER",
    PRODUCTS: "PRODUCTS",
    PAYMENT_METHOD: "PAYMENT METHOD",
  },
};

const RETURN_ELIGIBLE = "RETURN";
const CANCEL_ELIGIBLE = "CANCEL";

export {
  MY_ORDERS,
  ORDER_DETAILS,
  ORDER_DETAILS_MESSAGES,
  RETURN_ELIGIBLE,
  CANCEL_ELIGIBLE,
};



// WEBPACK FOOTER //
// ./src/constants/orderDetails.js